/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Material UI
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';

// Icons

// Actions
import * as GroupingModalActions from 'store/ducks/groupingModal/actions';

// Types
import { ApplicationState } from 'store';
import { GroupingModalOptionsInterface } from 'store/ducks/groupingModal/types';
import { ScheduleInterface } from 'store/ducks/reports/types';

// Constants
import IMAGES from 'constants/images';

// Styles
import useStyles from './GroupingModal.styles';

interface GroupingModalInterface {
  setIsGrouping?: any;
  groupOptions: GroupingModalOptionsInterface[];
  classGroup?: string;
  filtersAgrupmentsReports?: string;
  badge?: string;
  scheduleSubmissionDate?: ScheduleInterface;
  handleApplyGrouping?: (param: any) => void;
  controlFilters?: any;
}

type Props = GroupingModalInterface;

const GroupingModal: React.FC<Props> = ({
  setIsGrouping,
  groupOptions,
  classGroup,
  filtersAgrupmentsReports,
  badge,
  scheduleSubmissionDate,
  handleApplyGrouping,
  controlFilters,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const openDialog = useSelector(
    (state: ApplicationState) => state.groupingModal.openModal,
  );

  const selectedItems = useSelector(
    (state: ApplicationState) => state.groupingModal.selectedItems,
  );

  const handleCheck = (item: any) => {
    const updated = [...selectedItems];

    const index = selectedItems.findIndex((e) => e.key === item.key);

    if (index === -1) updated.push({ key: item.key, value: item.value });
    else updated.splice(index, 1);

    dispatch(
      GroupingModalActions.setSelectedItems({
        selectedItems: updated,
      }),
    );
  };

  return (
    <>
      <Tooltip
        className={filtersAgrupmentsReports ? filtersAgrupmentsReports : ''}
        title='Abre modal de agrupamento'
        placement='top'
        arrow>
        <Typography
          component='span'
          onClick={() =>
            dispatch(
              GroupingModalActions.setOpenModal({
                openModal: true,
              }),
            )
          }>
          {!filtersAgrupmentsReports ? (
            <Box className={classes.contentGroupings}>
              <Box className={classes.groupings}>
                <img src={IMAGES.ICONS.GROUPINGS} alt='groupings' />
              </Box>
              {!!selectedItems.length && (
                <Box className={classes.badge}>{selectedItems.length}</Box>
              )}
            </Box>
          ) : (
            // <Chip
            //   label='Agrupar'
            //   variant='outlined'
            //   classes={{
            //     deleteIcon: classes.deleteIcon,
            //     label: classes.chipLabel,
            //     root: classes.chipRoot,
            //   }}
            //   deleteIcon={<AddIcon />}
            //   onDelete={() => {}}
            //   className={!classGroup ? classes.chipAdd : classGroup}
            // />
            <>
              <Box
                minWidth='128px'
                display='flex'
                alignItems='center'
                justifyContent='space-between'>
                <img src={IMAGES.REPORTS_ICONS.AGRUPMENTS} alt=' filters' />
                <Typography>Agrupamentos</Typography>
              </Box>
              {scheduleSubmissionDate &&
              scheduleSubmissionDate.groupings.length > 0 ? (
                <Box className={badge ? badge : ''}>
                  {scheduleSubmissionDate.groupings.length}
                </Box>
              ) : null}
            </>
          )}
        </Typography>
      </Tooltip>
      <Dialog
        open={openDialog}
        aria-labelledby='dialog filter'
        fullWidth
        onClose={() => {
          dispatch(
            GroupingModalActions.setOpenModal({
              openModal: false,
            }),
          );
        }}>
        <DialogTitle id='dialog-filter'>Agrupar por:</DialogTitle>

        <DialogContent>
          <List dense>
            {groupOptions.map((item) => (
              <ListItem key={item.key} button>
                <ListItemText
                  id={item.key}
                  primary={item.value}
                  onClick={() => handleCheck(item)}
                  classes={{ root: classes.itemText }}
                />

                <ListItemSecondaryAction>
                  <Checkbox
                    edge='end'
                    color='primary'
                    onChange={() => handleCheck(item)}
                    checked={!!selectedItems.find((e) => e.key === item.key)}
                    inputProps={{ 'aria-labelledby': item.key }}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </DialogContent>

        <DialogActions className={classes.buttons}>
          <Button
            color='primary'
            onClick={() => {
              dispatch(
                GroupingModalActions.setOpenModal({
                  openModal: false,
                }),
              );

              dispatch(
                GroupingModalActions.setSelectedItems({
                  selectedItems: [],
                }),
              );
            }}>
            Cancelar
          </Button>

          <Button
            color='primary'
            variant='contained'
            onClick={() => {
              if (handleApplyGrouping) handleApplyGrouping(controlFilters);
              if (setIsGrouping instanceof Function) setIsGrouping(true);
              dispatch(
                GroupingModalActions.setOpenModal({
                  openModal: false,
                }),
              );
            }}>
            Agrupar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GroupingModal;
export { GroupingModal };
